<template>
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99998 0C8.83998 0 7.72665 0.54 6.99998 1.39333C6.27331 0.54 5.15998 0 3.99998 0C1.94665 0 0.333313 1.61333 0.333313 3.66667C0.333313 6.18667 2.59998 8.24 6.03331 11.36L6.99998 12.2333L7.96665 11.3533C11.4 8.24 13.6666 6.18667 13.6666 3.66667C13.6666 1.61333 12.0533 0 9.99998 0ZM7.06665 10.3667L6.99998 10.4333L6.93331 10.3667C3.75998 7.49333 1.66665 5.59333 1.66665 3.66667C1.66665 2.33333 2.66665 1.33333 3.99998 1.33333C5.02665 1.33333 6.02665 1.99333 6.37998 2.90667H7.62665C7.97331 1.99333 8.97331 1.33333 9.99998 1.33333C11.3333 1.33333 12.3333 2.33333 12.3333 3.66667C12.3333 5.59333 10.24 7.49333 7.06665 10.3667Z" />
  </svg>
</template>
<script>
export default {
  name: 'IconHeart'
}
</script>